import React from 'react';

import { RedirectClientToOnboardingV3 } from './RedirectClientToOnboardingV3';
import RedirectOrgToBrand from './RedirectOrgToBrand';

const GlobalRedirectsManager = () => {
  return (
    <>
      <RedirectOrgToBrand />
      <RedirectClientToOnboardingV3 />
    </>
  );
};

export default GlobalRedirectsManager;
